export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const ADD_MODAL_MESSAGE = 'ADD_MODAL_MESSAGE';
export const CLEAR_MODAL_MESSAGE = 'CLEAR_MODAL_MESSAGE';
// Secondary modal action types removed - migrated to Zustand store

export function show(content, modalProps = {}) {
  return {
    type: SHOW_MODAL,
    payload: {
      content,
      modalProps,
    },
  };
}

export function hide() {
  return {
    type: HIDE_MODAL,
  };
}

// Secondary modal action creators removed - migrated to Zustand store
// See: apps/lb-classroom/src/stores/use-secondary-modal-store.ts

export function addMessage(message, opts = {}) {
  return {
    type: ADD_MODAL_MESSAGE,
    payload: Object.assign({}, { message }, opts),
  };
}

export function clearMessage() {
  return {
    type: CLEAR_MODAL_MESSAGE,
  };
}
